// import { paginationDataToShow } from "../actions/generalActions";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ALL_ORDER_VIEW_REQUEST,
  ALL_ORDER_VIEW_SUCCESS,
  ORDER_BY_ID_SUCCESS,
  ALL_ORDER_VIEW_FAIL,
  ADDRESS_DELIVER_SUCCESS,
} from "../constants";

export const orderReducer = (
  state = {
    orders: {
      orders: [],
      from: null,
      to: null,
      loading: false,
    },
    deliverAddress: null,
  },
  action
) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
    case ALL_ORDER_VIEW_REQUEST:
      return {
        ...state,
        orders: {
          ...state.orders,
          loading: true,
        },
      };

    case ORDER_CREATE_SUCCESS: {
      const exists = state.orders?.orders?.some(
        (order) => order.id === action.payload.id
      );
      return {
        ...state,
        orders: {
          ...state.orders,
          loading: false,
          orders: exists
            ? state.orders.orders
            : [action.payload, ...(state.orders.orders || [])],
        },
      };
    }

    case ORDER_CREATE_FAIL:
    case ALL_ORDER_VIEW_FAIL:
      return {
        ...state,
        orders: {
          ...state.orders,
          loading: false,
        },
        error: action.payload,
      };

    case ALL_ORDER_VIEW_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        // orders: {
        //   // ...state.orders,
        //   loading: false,
        //   orders: action.payload,
        // },
      };

    case ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          loading: false,
        },
        orderDetails: action.payload,
      };
    case ADDRESS_DELIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        deliverAddress: action.payload,
      };
    default:
      return state;
  }
};
